import React from 'react';
import { chooseDataStateType } from '../molecules/MaintenanceModalDispLabels';

interface props {
  data: chooseDataStateType;
  setChooseData: (data: chooseDataStateType) => void;
  onOpen: () => void;
  dispString: string;
}

export const MaintenanceModalDispLabel: React.FC<props> = (props) => {
  const { data, setChooseData, onOpen, dispString } = props;
  return (
    <u>
      <label
        style={{
          cursor: 'pointer'
        }}
        onClick={() => {
          setChooseData(data);
          onOpen();
        }}
      >
        {dispString}
      </label>
    </u>
  );
};
